module.exports = __webpack_public_path__ + "img/01.00fb03ac.jpg";